import React, { useEffect } from "react";
import Banner from "../Components/Products/Banner";
import SectionOne from "../Components/Products/SectionOne";
import SectionTwo from "../Components/Products/SectionTwo";
import SectionThree from "../Components/Products/SectionThree";
import SectionFour from "../Components/Products/SectionFour";
import SectionFive from "../Components/Products/SectionFive";
import { usePagesBanners } from "../Context/PagesBannersContext";
import { useHome } from "../Context/HomeContext";
import { useProducts } from "../Context/ProductsContext";

function Products() {
  const { isBanner } = usePagesBanners();
  const { isSocial } = useHome();
  const { isBanners, getBanners } = useProducts();

  useEffect(() => {
    getBanners();
    window.scrollTo({ top: 0, behavior: "auto" });
  }, []);

  // فلترة البانرز بحيث يكون type = "products" مع التحقق من وجود الداتا
  const productBanners = isBanners?.data?.filter(
    (banner) => banner.type?.toLowerCase() === "products"
  ) || [];

  return (
    <div className="flex flex-col mx-[2rem] lg:mx-[7rem] md:mx-[4rem] items-center gap-10">
      <Banner isBanner={isBanner?.data[3]} isSocial={isSocial} />
      <SectionOne />
      <SectionTwo isBanners={productBanners} />
      <SectionThree />
      <SectionFour isBanners={productBanners} />
      <SectionFive />
    </div>
  );
}

export default Products;
